export default "__VITE_PUBLIC_ASSET__e7576d0e__"